export const EstadoDocumento = {
    pendiente: "PENDIENTE",
    recibidoVerificacion: "RECIBIDO VERIFICACION",
    rechazado: "RECHAZADO",
    aprobado: "APROBADO",
    anulado: "ANULADO USUARIO",
    enProceso: "DOCUMENTOS_ENVIADOS_APROBACION",
    borrado: "BORRADO",
    invalido: "INVALIDO",
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/modelo/EstadosDocumento.ts